/**
 * PATH: apps/qa/src/components/inspection/FieldLabel.tsx
 * PURPOSE: Form field label with optional required indicator and help tooltip
 * 
 * WHY: Consistent labeling across forms improves UX and accessibility.
 * The required indicator and tooltip provide clear guidance to users.
 */

import { HelpCircle } from 'lucide-react'
import { Tooltip } from './Tooltip'

interface FieldLabelProps {
  children: React.ReactNode
  required?: boolean
  tooltip?: string
  htmlFor?: string
}

export function FieldLabel({ children, required = false, tooltip, htmlFor }: FieldLabelProps) {
  return (
    <div className="flex items-center gap-2 mb-2">
      <label htmlFor={htmlFor} className="text-sm font-medium text-foreground">
        {children}
        {required && <span className="text-destructive ml-1">*</span>}
      </label>
      {tooltip && (
        <Tooltip content={<p className="text-xs">{tooltip}</p>}>
          <HelpCircle className="w-3.5 h-3.5 text-muted-foreground cursor-help" />
        </Tooltip>
      )}
    </div>
  )
}

export default FieldLabel
